var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7717 8.24872L19.0661 12.5432L19.0866 12.3183C19.0866 10.0619 17.2529 8.22827 14.9966 8.22827L14.7717 8.24872Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9966 5.50168C18.7594 5.50168 21.8133 8.55555 21.8133 12.3183C21.8133 13.1977 21.6361 14.0361 21.3293 14.8064L25.317 18.7941C27.3756 17.0763 28.998 14.8541 30.0001 12.3183C27.6347 6.33335 21.8201 2.09338 14.9967 2.09338C13.088 2.09338 11.2612 2.43419 9.56384 3.04769L12.5086 5.98564C13.2788 5.68573 14.1173 5.50168 14.9966 5.50168Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36331 1.78658L4.47169 4.89496L5.09202 5.5153C2.84254 7.27399 1.06339 9.61212 0 12.3183C2.35858 18.3033 8.17996 22.5432 14.9966 22.5432C17.1098 22.5432 19.1275 22.1342 20.9748 21.3912L21.5543 21.9706L25.5284 25.9515L27.2666 24.2201L3.10155 0.0483398L1.36331 1.78658ZM8.90254 9.31898L11.0089 11.4253C10.9475 11.7185 10.9066 12.0115 10.9066 12.3183C10.9066 14.5746 12.7403 16.4083 14.9966 16.4083C15.3034 16.4083 15.5965 16.3674 15.8828 16.306L17.9891 18.4123C17.0825 18.8622 16.0737 19.1349 14.9966 19.1349C11.2338 19.1349 8.17996 16.0811 8.17996 12.3183C8.17996 11.2413 8.45265 10.2324 8.90254 9.31898Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hidePassword.53b54f96205306771d672f57aa1933ce.svg";
export { ForwardRef as ReactComponent };